module.exports = __webpack_public_path__ + "img/fail.bad3b81a.png";